module.exports = __webpack_public_path__ + "img/DC.2460a356.png";